var $51739ee19c16f23a$exports = {};
$51739ee19c16f23a$exports = {
    "collapse": `Daralt`,
    "expand": `Geni\u{15F}let`
};


export {$51739ee19c16f23a$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
